export default __webpack_public_path__ + "static/media/icon-datatilsynet-logo.5e871464.svg";